import * as React from 'react';

// tslint:disable:max-line-length
export const PromotionsBonusIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
    <g fill="none" fillRule="evenodd">
      <circle cx="13" cy="13" r="13" fill="#2E9E00"/>
      <path fill="#FFF" d="M13 18.05l-3.384 1.978-.564-3.88-3.656-1.412 2.681-2.86-1.175-3.74 3.907.315L13 5.2l2.19 3.25 3.908-.313-1.175 3.74 2.681 2.859-3.656 1.412-.564 3.88z"/>
    </g>
  </svg>
);
